import React, {Component} from 'react';
import {Link} from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {FaEdit, FaTrash} from "react-icons/fa";

class ListOrderComponent extends Component {

    listInfoOrder = () => {
        return (
            this.props.order.order_info.map( (order_info, key) => (
                <div key={key}>
                    { order_info.value }
                </div>
            ))
        )
    }

    loadStatus = () => {
        if ( this.props.order.status === 'Pending' ) {
            return (
                <span className="text-danger">Chưa thanh toán</span>
            )
        }
        else if ( this.props.order.status === 'Finish' ) {
            return (
                <span className="text-success">Đã thanh toán</span>
            )
        }
        else if ( this.props.order.status === 'Waiting' ) {
            return (
                <span className="text-info">Thanh toán chờ</span>
            )
        }
        else if ( this.props.order.status === 'AdminCancel' ) {
            return (
                <span className="text-danger">Yêu cầu hủy</span>
            )
        }
        else {
            return (
                <span className="text-danger">Hủy</span>
            )
        }
    }

    render() {
        return (
            <tr>
                <td>{ this.props.order.text_date_create }</td>
                <td>
                    <Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.props.order.user_id}>{this.props.order.text_user_name}</Link>
                </td>
                <td>{ this.props.order.text_total }</td>
                <td>{ this.props.order.text_type_order }</td>
                <td>{ this.listInfoOrder() }</td>
                <td>{ this.loadStatus() }</td>
                <td>
                    <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Thông tin đơn hàng
                            </Tooltip>
                        )}
                        placement="top"
                    >
                        <button type="button" className="btn btn-warning btn-sm mr-1 text-light" onClick={ () => this.props.showModal( this.props.actionKey, 'infoOrder' ) }>
                            <FaEdit />
                        </button>
                    </OverlayTrigger>
                    {
                        this.props.order.status !== 'AdminCancel' ? (
                            <>
                                {
                                    this.props.order.status === 'Finish' || this.props.order.status === 'Waiting' ? (
                                        <OverlayTrigger
                                            delay={{ hide: 450, show: 300 }}
                                            overlay={(props) => (
                                                <Tooltip {...props}>
                                                    Yêu cầu hủy đơn hàng
                                                </Tooltip>
                                            )}
                                            placement="top"
                                        >
                                            <button type="button" className="btn btn-danger btn-sm mr-1" onClick={ () => this.props.showModal( this.props.actionKey, 'cancelOrder' ) }>
                                                <FaTrash />
                                            </button>
                                        </OverlayTrigger>
                                    ) : (
                                        <OverlayTrigger
                                            delay={{ hide: 450, show: 300 }}
                                            overlay={(props) => (
                                                <Tooltip {...props}>
                                                    Xóa đơn hàng
                                                </Tooltip>
                                            )}
                                            placement="top"
                                        >
                                            <button type="button" className="btn btn-danger btn-sm mr-1" onClick={ () => this.props.showModal( this.props.actionKey, 'deleteOrder' ) }>
                                                <FaTrash />
                                            </button>
                                        </OverlayTrigger>
                                    )
                                }
                            </>
                        ) : (
                            <></>
                        )
                    }
                </td>
            </tr>
        );
    }
}

export default ListOrderComponent;